"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
var Language;
(function (Language) {
    Language["Abkhazian"] = "Abkhazian";
    Language["Afar"] = "Afar";
    Language["Afrikaans"] = "Afrikaans";
    Language["Akan"] = "Akan";
    Language["Albanian"] = "Albanian";
    Language["AmericanEnglish"] = "American english";
    Language["Amharic"] = "Amharic";
    Language["Arabic"] = "Arabic";
    Language["Aragonese"] = "Aragonese";
    Language["Armenian"] = "Armenian";
    Language["Assamese"] = "Assamese";
    Language["Avaric"] = "Avaric";
    Language["Avestan"] = "Avestan";
    Language["Aymara"] = "Aymara";
    Language["Azerbaijani"] = "Azerbaijani";
    Language["Bambara"] = "Bambara";
    Language["Balearic"] = "Balearic";
    Language["Bashkir"] = "Bashkir";
    Language["Basque"] = "Basque";
    Language["Belarusian"] = "Belarusian";
    Language["Bengali"] = "Bengali";
    Language["Bhaya"] = "Bhaya";
    Language["Bharia"] = "Bharia";
    Language["Biharilanguages"] = "Bihari languages";
    Language["Bislama"] = "Bislama";
    Language["Bosnian"] = "Bosnian";
    Language["Breton"] = "Breton";
    Language["Bulgarian"] = "Bulgarian";
    Language["Burmese"] = "Burmese";
    Language["Catalan"] = "Catalan";
    Language["Canary"] = "Canary";
    Language["Valencian"] = " Valencian";
    Language["Chamorro"] = "Chamorro";
    Language["Chechen"] = "Chechen";
    Language["Chichewa"] = "Chichewa";
    Language["Chewa"] = " Chewa";
    Language["Nyanja"] = " Nyanja";
    Language["Chinese"] = "Chinese";
    Language["ChineseSimplified"] = "Chinese - simplified";
    Language["ChineseTraditional"] = "Chinese - traditional";
    Language["Chuvash"] = "Chuvash";
    Language["Cornish"] = "Cornish";
    Language["Corsican"] = "Corsican";
    Language["Cree"] = "Cree";
    Language["Croatian"] = "Croatian";
    Language["Czech"] = "Czech";
    Language["Danish"] = "Danish";
    Language["Divehi"] = "Divehi";
    Language["Dhivehi"] = " Dhivehi";
    Language["Maldivian"] = " Maldivian";
    Language["Dutch"] = "Dutch";
    Language["Flemish"] = "Flemish";
    Language["Dzongkha"] = "Dzongkha";
    Language["English"] = "English";
    Language["Esperanto"] = "Esperanto";
    Language["Estonian"] = "Estonian";
    Language["Ewe"] = "Ewe";
    Language["Faroese"] = "Faroese";
    Language["Fijian"] = "Fijian";
    Language["Finnish"] = "Finnish";
    Language["French"] = "French";
    Language["Fulah"] = "Fulah";
    Language["Galician"] = "Galician";
    Language["Georgian"] = "Georgian";
    Language["German"] = "German";
    Language["Greek"] = "Greek";
    Language["Modern"] = " Modern ";
    Language["Guarani"] = "Guarani";
    Language["Gujarati"] = "Gujarati";
    Language["Haitian"] = "Haitian";
    Language["HaitianCreole"] = " Haitian Creole";
    Language["Hausa"] = "Hausa";
    Language["Hebrew"] = "Hebrew";
    Language["Herero"] = "Herero";
    Language["Hindi"] = "Hindi";
    Language["HiriMotu"] = "Hiri Motu";
    Language["Hungarian"] = "Hungarian";
    Language["Interlingua"] = "Interlingua ";
    Language["Indonesian"] = "Indonesian";
    Language["Interlingue"] = "Interlingue";
    Language["Occidental"] = " Occidental";
    Language["Irish"] = "Irish";
    Language["Igbo"] = "Igbo";
    Language["Inupiaq"] = "Inupiaq";
    Language["Ido"] = "Ido";
    Language["Icelandic"] = "Icelandic";
    Language["Italian"] = "Italian";
    Language["Inuktitut"] = "Inuktitut";
    Language["Japanese"] = "Japanese";
    Language["Javanese"] = "Javanese";
    Language["Kalaallisut"] = "Kalaallisut";
    Language["Greenlandic"] = " Greenlandic";
    Language["Kannada"] = "Kannada";
    Language["Kanuri"] = "Kanuri";
    Language["Kashmiri"] = "Kashmiri";
    Language["Kazakh"] = "Kazakh";
    Language["CentralKhmer"] = "Central Khmer";
    Language["Kikuyu"] = "Kikuyu";
    Language["Gikuyu"] = " Gikuyu";
    Language["Kinyarwanda"] = "Kinyarwanda";
    Language["Kirghiz"] = "Kirghiz";
    Language["Kyrgyz"] = " Kyrgyz";
    Language["Komi"] = "Komi";
    Language["Kongo"] = "Kongo";
    Language["Korean"] = "Korean";
    Language["Kurdish"] = "Kurdish";
    Language["Kuanyama"] = "Kuanyama";
    Language["Kwanyama"] = " Kwanyama";
    Language["Latin"] = "Latin";
    Language["Luxembourgish"] = "Luxembourgish";
    Language["Letzeburgesch"] = " Letzeburgesch";
    Language["Ganda"] = "Ganda";
    Language["Limburgan"] = "Limburgan";
    Language["Limburger"] = " Limburger";
    Language["Limburgish"] = " Limburgish";
    Language["Lingala"] = "Lingala";
    Language["Lao"] = "Lao";
    Language["Lithuanian"] = "Lithuanian";
    Language["LubaKatanga"] = "Luba-Katanga";
    Language["Latvian"] = "Latvian";
    Language["Manx"] = "Manx";
    Language["Macedonian"] = "Macedonian";
    Language["Malagasy"] = "Malagasy";
    Language["Malay"] = "Malay";
    Language["Malayalam"] = "Malayalam";
    Language["Maltese"] = "Maltese";
    Language["Maori"] = "Maori";
    Language["Marathi"] = "Marathi";
    Language["Marshallese"] = "Marshallese";
    Language["Mongolian"] = "Mongolian";
    Language["Nauru"] = "Nauru";
    Language["Navajo"] = "Navajo";
    Language["Navaho"] = " Navaho";
    Language["NorthNdebele"] = "North Ndebele";
    Language["Nepali"] = "Nepali";
    Language["Ndonga"] = "Ndonga";
    Language["NorwegianBokm\u00E5l"] = "Norwegian Bokm\u00E5l";
    Language["NorwegianNynorsk"] = "Norwegian Nynorsk";
    Language["Norwegian"] = "Norwegian";
    Language["SichuanYi"] = "Sichuan Yi";
    Language["Nuosu"] = " Nuosu";
    Language["SouthNdebele"] = "South Ndebele";
    Language["Occitan"] = "Occitan";
    Language["Ojibwa"] = "Ojibwa";
    Language["ChurchSlavic"] = "Church\u00A0Slavic";
    Language["OldSlavonic"] = " Old Slavonic";
    Language["ChurchSlavonic"] = " Church Slavonic";
    Language["OldBulgarian"] = " Old Bulgarian";
    Language["OldChurchSlavonic"] = " Old\u00A0Church\u00A0Slavonic";
    Language["Oromo"] = "Oromo";
    Language["Oriya"] = "Oriya";
    Language["Ossetian"] = "Ossetian";
    Language["Ossetic"] = " Ossetic";
    Language["Punjabi"] = "Punjabi";
    Language["Panjabi"] = " Panjabi";
    Language["Pali"] = "Pali";
    Language["Persian"] = "Persian";
    Language["Polish"] = "Polish";
    Language["Pashto"] = "Pashto";
    Language["Pushto"] = " Pushto";
    Language["Portuguese"] = "Portuguese";
    Language["Quechua"] = "Quechua";
    Language["Romansh"] = "Romansh";
    Language["Rundi"] = "Rundi";
    Language["Romanian"] = "Romanian";
    Language["Moldavian"] = " Moldavian";
    Language["Moldovan"] = " Moldovan";
    Language["Russian"] = "Russian";
    Language["Sanskrit"] = "Sanskrit";
    Language["Sardinian"] = "Sardinian";
    Language["Sindhi"] = "Sindhi";
    Language["NorthernSami"] = "Northern Sami";
    Language["Samoan"] = "Samoan";
    Language["Sango"] = "Sango";
    Language["Serbian"] = "Serbian";
    Language["Gaelic"] = "Gaelic";
    Language["ScottishGaelic"] = " Scottish Gaelic";
    Language["Shona"] = "Shona";
    Language["Sinhala"] = "Sinhala";
    Language["Sinhalese"] = " Sinhalese";
    Language["Slovak"] = "Slovak";
    Language["Slovakian"] = "Slovakian";
    Language["Slovenian"] = "Slovenian";
    Language["Somali"] = "Somali";
    Language["SouthernSotho"] = "Southern Sotho";
    Language["Spanish"] = "Spanish";
    Language["Castilian"] = " Castilian";
    Language["Sundanese"] = "Sundanese";
    Language["Swahili"] = "Swahili";
    Language["Swati"] = "Swati";
    Language["Swedish"] = "Swedish";
    Language["Tamil"] = "Tamil";
    Language["Telugu"] = "Telugu";
    Language["Tajik"] = "Tajik";
    Language["Thai"] = "Thai";
    Language["Tigrinya"] = "Tigrinya";
    Language["Tibetan"] = "Tibetan";
    Language["Turkmen"] = "Turkmen";
    Language["Tagalog"] = "Tagalog";
    Language["Tswana"] = "Tswana";
    Language["Tonga"] = "Tonga ";
    Language["Turkish"] = "Turkish";
    Language["Tsonga"] = "Tsonga";
    Language["Tatar"] = "Tatar";
    Language["Twi"] = "Twi";
    Language["Tahitian"] = "Tahitian";
    Language["Uighur"] = "Uighur";
    Language["Uyghur"] = " Uyghur";
    Language["Ukrainian"] = "Ukrainian";
    Language["Urdu"] = "Urdu";
    Language["Uzbek"] = "Uzbek";
    Language["Venda"] = "Venda";
    Language["Vietnamese"] = "Vietnamese";
    Language["Volap\u00FCk"] = "Volap\u00FCk";
    Language["Walloon"] = "Walloon";
    Language["Welsh"] = "Welsh";
    Language["Wolof"] = "Wolof";
    Language["WesternFrisian"] = "Western Frisian";
    Language["Xhosa"] = "Xhosa";
    Language["Yiddish"] = "Yiddish";
    Language["Yoruba"] = "Yoruba";
    Language["Zhuang"] = "Zhuang";
    Language["Chuang"] = " Chuang";
    Language["Zulu"] = "Zulu";
})(Language = exports.Language || (exports.Language = {}));
//# sourceMappingURL=language.js.map